
export const AreYouSureDelete = (itemName: string) => {
  return `You are about to delete a ${itemName}.  Once deleted, they can be only be recovered by your administrator.`
}
